import { lazy, Suspense, useEffect, useState } from "react";
import { registerToastHost } from "@/lib/toast";

const ToastHost = lazy(() => import("@/components/ToastHost"));

export default function ToastBootstrap() {
  const [enabled, setEnabled] = useState(false);
  useEffect(() => registerToastHost(() => setEnabled(true)), []);
  return enabled ? <Suspense fallback={null}><ToastHost /></Suspense> : null;
}